wbApp.filter('datePartOccupied', ['$translate', function ($translate) {
    return function (input) {
        switch (input) {
            case 'am':
                return $translate.instant('TXT_DATE_PART_AM');
            case 'pm':
                return $translate.instant('TXT_DATE_PART_PM');
            case 'both':
                return $translate.instant('TXT_DATE_PART_FULL_DAY');
            case 'indeterminate':
                return $translate.instant('TXT_DATE_PART_INDETERMINATE');
        }
        return '';
    };
}]);